import { Grid, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
    name: {
        fontSize: '1rem',
    },
    propertyName: {
        fontWeight: 'bold',
    },
});

const AnnouncerTooltip = ({ estado, latitud, longitud, nivel, nombre }) => {
    const classes = useStyles();

    return (
        <Grid container>
            <Grid item xs={12}>
                <span className={classes.name}>{nombre}</span>
            </Grid>
            <Grid item xs={12}>
                <span className={classes.propertyName}>Coordenadas: </span>
                {`${latitud}, ${longitud}`}
            </Grid>
{/*              <Grid item xs={12}>
                <span className={classes.propertyName}>Nivel: </span>
                {nivel}
            </Grid> */}
            <Grid item xs={12}>
                <span className={classes.propertyName}>Estado: </span>
                {estado !== 4 ? 'Operando' : estado === 4 ? 'Desconectado' : undefined}
            </Grid>
        </Grid>
    );
};

AnnouncerTooltip.propTypes = {
    estado: PropTypes.number.isRequired,
    latitud: PropTypes.number.isRequired,
    longitud: PropTypes.number.isRequired,
    nivel: PropTypes.number.isRequired,
    nombre: PropTypes.string.isRequired,
};

export default AnnouncerTooltip;
